export const ANALYTICS_KEYS = {
  TEST_REPORT: {
    TASK_PLAYER_NOTE_BTN: "test_report_task_player_note_btn",
    TASK_PLAYER_CLIP_BTN: "test_report_task_player_clip_btn",
    TASK_PLAYER_BOOKMARK_BTN: "test_report_task_player_bookmark_btn",
  },
  VIDEO_PLAYER: {
    NOTE_BTN: "video_player_note_btn",
    CLIP_BTN: "video_player_clip_btn",
    BOOKMARK_BTN: "video_player_bookmark_btn",
  },
  TEST_CREATION: {
    TASK_CHANGE_CLOSE_BTN: "test_creation_task_change_close_btn",
    TASK_SELECTION_CHECKBOX: "test_creation_task_selection_checkbox",
    TASK_SELECTION_OPEN_BTN: "test_creation_task_selection_open_btn",
  },
  GLOBAL_SIDEBAR: {
    EXPAND_SIDEBAR: "global_sidebar_expand_sidebar",
    COLLAPSE_SIDEBAR: "global_sidebar_collapse_sidebar",
    HIDE_SIDEBAR: "global_sidebar_hide_sidebar",
  },
  TOOLKIT: {
    TEST_CREATION: {
      TEST_LAUNCH_BTN: "toolkit_test_creation_test_launch_btn",
      TEST_PREVIEW_BTN: "toolkit_test_creation_test_preview_btn",
      TEST_DROPDOWN_BTN: "toolkit_test_creation_test_dropdown_btn",
      NEXT_TAB_BTN: "toolkit_test_creation_next_tab_btn",
      PREV_TAB_BTN: "toolkit_test_creation_prev_tab_btn",
      ADD_TASK_BTN: "toolkit_test_creation_add_task_btn",
      EDIT_TASK_BTN: "toolkit_test_creation_edit_task_btn",
      DELETE_TASK_BTN: "toolkit_test_creation_delete_task_btn",
      SHUFFLE_TASKS_CHECKBOX: "toolkit_test_creation_shuffle_tasks_checkbox",
    },
    REPORT: {
      EXPORT_BTN: "toolkit_report_export_btn",
      GET_TEST_LINK_BTN: "toolkit_report_get_test_link_btn",
    },
  },
};
